import { useQuery } from '@tanstack/react-query';

import { tsrestClient } from '@portal/provider/tsrest';

export const useServerVersion = () => {
  return tsrestClient.system.get.useQuery(
    ['system-version'],
    {},
    {
      refetchInterval: false, // Don't refetch automatically since version doesn't change
      retry: 1, // Only retry once if it fails
      staleTime: 10 * 60 * 1000, // Consider data fresh for 5 minutes
    }
  );
};
